export default __webpack_public_path__ + "static/media/balanced.9380bd05.jpg";